export default class Passwords4i {
    constructor() {
		this.form = null;
		this.passwordFields = [];
		this.toggleBtns = [];

		this.toggleVisibility = this.toggleVisibility.bind(this);
	}

    init(form){
		if (!form || !(form instanceof HTMLElement)) {
			console.error("Passwords4i: Expected a valid form element.");
			return false;
		}
 
		this.form = form;
		this.passwordFields = Array.from(form.querySelectorAll('input[type="password"]'));
		this.toggleBtns = Array.from(form.querySelectorAll(".toggle-password"));

		this.bindToggleButtons();
	}

    bindToggleButtons() {
		this.toggleBtns.forEach(btn => {
			btn.removeEventListener("click", this.toggleVisibility);
			btn.addEventListener("click", this.toggleVisibility);

            btn.setAttribute("role", "button");
			btn.setAttribute("tabindex", "0");
			if (!btn.hasAttribute("aria-pressed")) {
				btn.setAttribute("aria-pressed", "false");
			}
		});
	}

    toggleVisibility(e) {
		e.preventDefault();
		const btn = e.currentTarget;
		const targetSelector = btn.getAttribute("toggle");

		if (!targetSelector) {
			console.warn("Passwords4i: Toggle button missing 'toggle' attribute.");
			return;
		}

		const input = this.form.querySelector(`#${targetSelector}`);
		if (!input) {
			console.error(`Passwords4i: No input found with ID "${targetSelector}".`);
			return;
		}

		const isPassword = input.type === "password";
		input.type = isPassword ? "text" : "password";
		btn.setAttribute("aria-pressed", isPassword ? "true" : "false");
	}

    async validate(el) {
		const threshold = parseInt(el.getAttribute("data-val-password-complexity-threshold"), 10) || 3;
		const val = el.value || "";

		const criteria = [
			{ test: /[a-z]/.test(val), message: `At least one lowercase letter.`},
			{ test: /[A-Z]/.test(val), message: `At least one uppercase letter.` },
			{ test: /\d/.test(val), message: `At least one number.` },
			{ test: /[!@#^&*()+_,.{}?~]/.test(val), message: `At least one special character.` }
		];

		const passed = criteria.filter(c => c.test);
		const failed = criteria.filter(c => !c.test);

		if (passed.length < threshold) {
			return failed.length > 0 ? `Password must include:<br/> ${failed.map(c => c.message).join(`<br/>`)}` : "";
		}
		return null;
	}
}